import { IonSpinner } from '@ionic/react';
import classNames from 'classnames';

import { UiSvgIcon } from '@/components/ui/SvgIcon';

import './BtnGoPremium.scss';

export const OnboardingPaywallBtnGoPremium: React.FC<{
  onClick?: () => void;
  type: 'button' | 'submit';
  loading?: boolean;
  disabled?: boolean;
  className?: string;
}> = ({ onClick, type, disabled, loading, className }) => {
  return (
    <button
      className={classNames('go-premium-btn', className)}
      onClick={onClick}
      // eslint-disable-next-line react/button-has-type
      type={type}
      disabled={disabled}
    >
      {loading ? (
        <IonSpinner name="bubbles" className="icon" />
      ) : (
        <UiSvgIcon symbol="three-stars" className="icon" />
      )}
      <span>Go Premium</span>
    </button>
  );
};
